import React from 'react'

const Footer = () => {
  return (
    <div className='copyright'>
      <p>Copyright &copy; Itodo </p>
    </div>
  )
}

export default Footer
